import React from "react";
import styled from "styled-components";

const Img = styled.img<{
    width: number;
    height: number;
}>`
    cursor: pointer;
    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
`;

type EditorMenuIconProps = {
    enableDarkTheme: boolean;
    width?: number;
    height?: number;
    onClick: () => void;
    w: string;
    b: string;
};

export default class Icon extends React.Component<EditorMenuIconProps> {
    render() {
        const { enableDarkTheme, w, b } = this.props;

        return (
            <Img
                src={enableDarkTheme ? w : b}
                width={this.props.width || 36}
                height={this.props.height || 36}
                onClick={this.props.onClick}
            />
        );
    }
}
